import React from "react";
import LegalLayout from "../components/LegalLayout";

export default function RefundPage() {
  return (
    <LegalLayout title="Refund Policy" lastUpdated="May 3, 2026">
      <p>We want Ascend to be worth every penny. If something’s wrong, tell us. Here’s how refunds work.</p>

      <h2 className="font-display text-[22px] text-[#0f1724] pt-4">1. Free Trial</h2>
      <p>All new subscribers receive a 3-day free trial. You can cancel during the trial and be charged nothing.</p>

      <h2 className="font-display text-[22px] text-[#0f1724] pt-4">2. Monthly Plans</h2>
      <p>Monthly subscription payments are generally non-refundable. If you cancel, you keep access through the end of your current paid period.</p>

      <h2 className="font-display text-[22px] text-[#0f1724] pt-4">3. Annual Plans</h2>
      <p>Annual plans may be refunded on a pro-rata basis within 14 days of purchase if you have not used the service materially. Email <a className="text-[#486a8f] underline" href="mailto:support@ascendhigher.life">support@ascendhigher.life</a> within that window.</p>

      <h2 className="font-display text-[22px] text-[#0f1724] pt-4">4. Billing Errors</h2>
      <p>If you were charged in error, duplicate-charged, or charged after cancellation, we will refund the incorrect charge in full within 10 business days of verification.</p>

      <h2 className="font-display text-[22px] text-[#0f1724] pt-4">5. How to Request a Refund</h2>
      <p>Email <a className="text-[#486a8f] underline" href="mailto:support@ascendhigher.life">support@ascendhigher.life</a> with your account email, date of charge, and reason. We aim to respond within 2 business days.</p>

      <h2 className="font-display text-[22px] text-[#0f1724] pt-4">6. App Store Purchases</h2>
      <p>If you subscribed through Apple or Google, refund requests must go through their respective support channels. We do not control App Store billing.</p>

      <h2 className="font-display text-[22px] text-[#0f1724] pt-4">7. Statutory Rights</h2>
      <p>Nothing in this policy limits any rights you may have under applicable consumer protection laws.</p>
    </LegalLayout>
  );
}
